// extracted by mini-css-extract-plugin
module.exports = {"warning":"DuplicateIdsWarning_warning__tSJOq","lenkeInline":"DuplicateIdsWarning_lenkeInline___858K"};